import type { Shape } from '@hcie/shared';

function clamp01(n: number) {
    return n < 0 ? 0 : (n > 1 ? 1 : n);
}

function distToSegment(px: number, py: number, x1: number, y1: number, x2: number, y2: number) {
    const vx = x2 - x1;
    const vy = y2 - y1;
    const wx = px - x1;
    const wy = py - y1;
    const len2 = vx * vx + vy * vy;
    const t = len2 > 0 ? clamp01((wx * vx + wy * vy) / len2) : 0;
    const cx = x1 + t * vx;
    const cy = y1 + t * vy;
    return Math.hypot(px - cx, py - cy);
}

function inRect(px: number, py: number, x1: number, y1: number, x2: number, y2: number, tol: number) {
    const minX = Math.min(x1, x2) - tol;
    const maxX = Math.max(x1, x2) + tol;
    const minY = Math.min(y1, y2) - tol;
    const maxY = Math.max(y1, y2) + tol;
    return px >= minX && px <= maxX && py >= minY && py <= maxY;
}

export function findHitShapeIndex(shapes: Shape[], x: number, y: number, tolerancePx = 6) {
    for (let i = shapes.length - 1; i >= 0; i--) {
        const s: any = shapes[i];
        const tol = tolerancePx + ((s.style?.width ?? 1) / 2);
        if (s.type === 'line') {
            if (distToSegment(x, y, s.x1, s.y1, s.x2, s.y2) <= tol) return i;
            continue;
        }
        if (s.type === 'circle') {
            const r = Math.hypot(s.x2 - s.x1, s.y2 - s.y1);
            const d = Math.hypot(x - s.x1, y - s.y1);
            if (s.style?.fill) {
                if (d <= r + tol) return i;
            } else {
                if (Math.abs(d - r) <= tol) return i;
            }
            continue;
        }
        // rect, ellipse, roundrect: bbox hit, with optional stroke-only preference
        if (inRect(x, y, s.x1, s.y1, s.x2, s.y2, tol)) return i;
    }
    return -1;
}

